import { ExecutionStep } from '../types/rust-engine-interfaces';
import { unwrapInput, genericFallback, normalizeGraph } from './fallback-helpers';

export async function executeUniversalFallback(
  algorithmId: string,
  inputData: unknown,
  category: string,
): Promise<ExecutionStep[]> {
  const id = algorithmId.toLowerCase();
  const cat = category.toLowerCase();
  const raw = unwrapInput(inputData);
  try {
    // Sorting category is the most common; still load it lazily to keep the main chunk small.
    if (cat === 'sorting') {
      const { sortingFallback } = await import('./sorting');
      return sortingFallback(id, raw);
    }
    // floyd-warshall emits a matrix payload regardless of category — dispatch directly
    // so it bypasses graphFallback (which emits graph payloads) and reaches MatrixVisualizer
    // via ALGORITHM_ROUTE_OVERRIDE in VisualizerCanvas.
    if (id.includes('floyd')) {
      const { floydWarshall } = await import('./graph');
      return floydWarshall(normalizeGraph(raw));
    }
    if (cat === 'graph') {
      const { graphFallback } = await import('./graph');
      return graphFallback(id, raw);
    }
    if (cat === 'dp') {
      const { dpFallback } = await import('./dp');
      return dpFallback(id, raw);
    }
    if (cat === 'string') {
      const { stringFallback } = await import('./string');
      return stringFallback(id, raw);
    }
    if (cat === 'tree') {
      const { treeFallback } = await import('./tree');
      return treeFallback(id, raw);
    }
    if (cat === 'math') {
      const { mathFallback } = await import('./math');
      return mathFallback(id, raw);
    }
    if (cat === 'greedy') {
      const { greedyFallback } = await import('./greedy');
      return greedyFallback(id, raw);
    }
    if (cat === 'data structures' || cat === 'data-structures') {
      const { dsFallback } = await import('./data-structures');
      return dsFallback(id, raw);
    }
    if (cat === 'backtracking') {
      const { backtrackingFallback } = await import('./backtracking');
      return backtrackingFallback(id, raw);
    }
    if (cat === 'search') {
      const { searchFallback } = await import('./search');
      return searchFallback(id, raw);
    }
    if (cat === 'geometry') {
      const { geometryFallback } = await import('./geometry');
      return geometryFallback(id, raw);
    }
  } catch (e) {
    console.warn('[UniversalFallback] algorithm-specific path failed', e);
  }
  return genericFallback(id, raw, cat);
}
